import { collection, Loader, pubsub } from '@services';
import { getSectionId } from '@utils';

class ListingGrid extends HTMLElement {
  /** @type {(() => void) | undefined} */ #unsubscriber;
  /** @type {import('./services/loader/index.js').Loader} */ #loader;
  /** @type {HTMLElement} */ #closestSection = this.closest('[id^="shopify-section-"]');
  /** @type {string} */ #sectionId = getSectionId(this.#closestSection);

  connectedCallback() {
    collection.sections.push(this.#sectionId);

    this.#loader = new Loader(this, { events: ['collection:filter'], fixed: true });

    // Subscribe to filters updated event
    /**
     * @param {{ status: 'pending' | 'success' | 'error'; data?: { sections?: Array<{ section: string; html: Document }> } }} payload
     */
    this.#unsubscriber = pubsub.subscribe('collection:filter', ({ status, data }) => {
      status === 'success' && this.#replaceListingGrid(data.sections);
    });
  }

  disconnectedCallback() {
    this.#unsubscriber();
    this.#loader?.destroy();
  }

  /**
   * Replace the listing grid with updated section content.
   * @param {Array<{ section: string; html: Document }>} sections
   * @returns {void}
   */
  #replaceListingGrid(sections) {
    const section = sections.find(({ section }) => section === this.#sectionId);
    if (!section) return;

    const parsedListingGrid = section.html.querySelector('listing-grid');

    // Clone the element to avoid modifying the shared HTML object
    const clonedListingGrid = parsedListingGrid.cloneNode(true);

    this.innerHTML = clonedListingGrid.innerHTML;
  }
}

customElements.define('listing-grid', ListingGrid);
